import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from './News.API';

class NewsStore {

  listTestimonialContractor = async () => {
    const res = await api.getListTestimonial({ Type: 'contractor' });
    const json = await res.json();
    return json;
  }

  listTestimonialSupplier = async () => {
    const res = await api.getListTestimonial({ Type: 'supplier' });
    const json = await res.json();
    return json;
  }

  termsAndPolicies = async () => {
    const res = await api.termsAndPolicies();
    const json = await res.json();
    return json;
  }

  getNews = async () => {
    const res = await api.getNews();
    const json = await res.json();
    return json;
  }

  getNewsDetail = async (id) => {
    const res = await api.getNews({ id, _limit: 1 });
    const json = await res.json();
    if (VarHelper.isArr(json) && json.length > 0) return json[0];
    return null;
  }

  getJobs = async () => {
    const res = await api.getJobs({ 'Show Public': 1 });
    const json = await res.json();
    return json;
  }

  getRelatedArticleContractor = async () => {
    const res = await api.getRelatedArticleContractor();
    const json = await res.json();
    let result = [];
    let promiseArr = json.map( async (val, index) => {
      try {
        const linkImage = val._links['wp:featuredmedia'][0].href;
        const imgRes = await Request.getNoHeader(linkImage);
        const imgJSON = await imgRes.json();
        result.push({
          link: val.link,
          title: val.title.rendered,
          image: imgJSON.media_details.sizes.medium.source_url,
        });
      } catch(err) { console.log(err) }
    });
    await Promise.all(promiseArr);
    return result;
  }

  getFeatureMemberLogo = async () => {
    const res = await api.getFeatureMemberLogo();
    const json = await res.json();
    return json;
  }

  getImageHomePage = async () => {
    try {
      const res = await api.getImageHomePage();
      const json = await res.json();
      if (VarHelper.isArr(json) && !!json[0]) {
        return json[0]['Data'].image;
      }
      return undefined;
    } catch (err) {
      return undefined;
    }
  }

  getTutorialsInternal = async () => {
    const res = await api.getTutorials({ 'Target User': 'internal' });
    const json = await res.json();
    return json;
  }

  getBanUserAdmin = async () => {
    try {
      const res = await api.getBanUserAdmin();
      const json = await res.json();
      if (VarHelper.isArr(json) && !!json[0]) {
        return json[0]['Data'];
      }
      return undefined;
    } catch (err) {
      return undefined;
    }
  }
}

export default new NewsStore();


// WEBPACK FOOTER //
// ./src/services/news/News.Store.js